/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How the renter gets from the airport to the rental car counter
 * @export
 */
export const PickupType = {
    InTerminal: 'IN_TERMINAL',
    OnAirport: 'ON_AIRPORT',
    Shuttle: 'SHUTTLE'
} as const;
export type PickupType = typeof PickupType[keyof typeof PickupType];


export function instanceOfPickupType(value: any): boolean {
    for (const key in PickupType) {
        if (Object.prototype.hasOwnProperty.call(PickupType, key)) {
            if (PickupType[key as keyof typeof PickupType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PickupTypeFromJSON(json: any): PickupType {
    return PickupTypeFromJSONTyped(json, false);
}

export function PickupTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PickupType {
    return json as PickupType;
}

export function PickupTypeToJSON(value?: PickupType | null): any {
    return value as any;
}

export function PickupTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PickupType {
    return value as PickupType;
}

